import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { DocumentService, NotifyOpenFormSidebarVault } from '@app/shared/services';
import { Subscription } from 'rxjs';
import { AddTrustTemplate } from './add-trust-template.interfaces';
import { EditTemplateBasicFormComponent } from '../discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/create-associated-form/edit-template-basic-form/edit-template-basic-form.component';
import { AskSecurityKeyPasswordComponent } from '@app/modules/vault/components/dialogs/ask-security-key-password/ask-security-key-password.component';
import { CryptoService } from '@app/shared/services/crypto/crypto.services';
import { loaderTypes } from '../loader/loader';
import { InboxSettingsService } from '@app/shared/services/settings/inbox-settings/inbox-settings.service';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'add-trust-template-dialog',
  templateUrl: './add-trust-template-dialog.component.html',
  styleUrls: ['./add-trust-template-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddTrustTemplateDialogComponent implements OnInit, OnDestroy {
  current_template;
  forms = [];
  visibility = false;
  @ViewChild(EditTemplateBasicFormComponent) editTemplateBasicForm!: EditTemplateBasicFormComponent;
  formData = [];
  beneFicaryForm = [];
  savingForm = false;
  Form1;
  security_key;
  manageSecuritykey;
  sk;
  formEncryptionKey;
  vault_user_form_id;
  subscription = new Subscription();
  documentForm: UntypedFormGroup;
  securityStateObject;
  entityName;
  is_secure = false;
  loadingItems = [{ id: 1 }, { id: 2 }];
  vault_id;
  vault_list = [];
  currentUserData;
  prefillApplied = false;
  prefillRetryCount = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AddTrustTemplate,
    public dialogRef: MatDialogRef<AddTrustTemplateDialogComponent>,
    private vaultService: VaultStoreEffects,
    private _inboxService: InboxSettingsService,
    private dialog: MatDialog,
    private documentService: DocumentService,
    private cd: ChangeDetectorRef,
    private _notifyOpenFormSidebarVault: NotifyOpenFormSidebarVault,
    private cryptoService: CryptoService,
    private formBuilder: UntypedFormBuilder,
    private loginService: LoginStoreEffects
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state?.data) {
          this.currentUserData = state.data;
        }
      })
    );

    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.forms = state.forms;
        this.vault_list = state.vaults;
      })
    );

    this.initData();
  }

  initData() {
    this.current_template = this.forms.find((x) => x.id == this.data.vaultFormId);
    this.formData = this.current_template.template;
    this.createformIdForFirstUploadDocument();
    this.documentForm = this.formBuilder.group({
      documentType: ['', Validators.required],
      documentName: ['', Validators.required],
      status_progress: ['need to add', Validators.required],
      formSelection: ['', Validators.required],
      selectSaveFolder: ['', Validators.required],
      selectOfficeSaveFolder: ['', Validators.required],
      dynamicFieldsForm: new UntypedFormArray([]),
      beneFicaryForm: new UntypedFormArray([]),
      attributeFormsList: new UntypedFormArray([]),
      showNotes: [''],
      physicalLocation: [''],
      notes: [''],
      expiration_date: [''],
      expiration_notification: [''],
      review_date: [''],
      review_notification: [''],
      renewal_notification: [''],
      renewal_date: [''],
      recurring_expiration: [''],
      value_currency: ['USD'],
      value_current_currency: [''],
      value_is_appraisal: [''],
      value_appraisal_date: [''],
    });
    this.applyPrefillData();
  }

  loadDatawithTamplet(res) {
    const form_data = JSON.parse(res['vaultFormData'][0]['form_data']);
    this.Form1 = JSON.parse(res['vaultFormData'][0]['template']);
    this.formEncryptionKey = res['vaultFormData'][0]['encryption_key'];
    if (res['vaultFormData'][0]['security_key'] != null && res['vaultFormData'][0]['security_key'] != undefined) {
      this.is_secure = true;
      this.openSecurityPopup(res);
    } else {
      this.documentForm.controls.dynamicFieldsForm.setValue([form_data.dynamicFieldsForm]);
      this.beneFicaryForm = form_data.beneFicaryForm;
    }
  }
  openSecurityPopup(res) {
    const modalRef2 = this.dialog.open(AskSecurityKeyPasswordComponent, {
      data: {
        currentuserId: this.currentUserData.id,
        currentValutUserId: this.currentUserData.id,
        vaultFormId: this.data.id,
        data: res['vaultFormData'][0],
      },
      disableClose: true,
      panelClass: 'full-window-dialog-2',
      autoFocus: false,
    });

    this.subscription.add(
      modalRef2.afterClosed().subscribe((result) => {
        if (result?.isVerify) {
          // //decrypt form data
          this.sk = result.sk;
          this.security_key = result.security_key;
          this.manageSecuritykey = [result.security_key];
          if (res['vaultFormData'][0]['form_data'] != null && res['vaultFormData'][0]['form_data'] != undefined) {
            res['vaultFormData'][0]['form_data'] = this.cryptoService.decryptData(
              JSON.parse(res['vaultFormData'][0]['form_data']),
              result.security_key,
              result.sk
            );
          }
          let form_data = res['vaultFormData'][0]['form_data'];
          form_data = JSON.parse(form_data);
          this.documentForm.controls.dynamicFieldsForm.setValue([form_data.dynamicFieldsForm]);
          this.beneFicaryForm = form_data.beneFicaryForm;
        } else {
        }
      })
    );
  }

  createformIdForFirstUploadDocument() {
    if (this.data?.is_edit) {
      this.visibility = true;
      this.vault_user_form_id = this.data.id;
      this.subscription.add(
        this.documentService.getformTempletByid(this.currentUserData.id, this.data.id).subscribe((res) => {
          try {
            this.vault_id = this.data?.vault_id ? this.data?.vault_id : res.data.vaultFormData[0].vault_id;
            this.securityStateObject = res.data.publicKey;
          } catch (error) {}
          this.loadDatawithTamplet(res.data);
        })
      );
    } else {
      this.visibility = false;
      let data = {
        user_id: this.currentUserData.id,
        vault_form_id: this.data.vaultFormId,
        url: 'my-vault/0',
        vaultId: this.data?.vault_id,
        hub_vault_user_form_id: this.data.hub_vault_user_form_id,
        origin: this.data.origin,
        onboarding_discovery_master_id: this.data.onboarding_discovery_master_id,
        onboarding_discovery_master_paths_id: this.data.pathid,
        discovery_sub_type_id: this.data.discovery_sub_type_id,
      };
      if (data.origin == null || data.origin == undefined) {
        delete data.origin;
      }
      if (data.vaultId == null || data.vaultId == undefined) {
        delete data.vaultId;
      }

      this.subscription.add(
        this.documentService.getforIdForFirstUploadDocument(data, loaderTypes.mainAnimation).subscribe(
          (res) => {
            try {
              this.vault_id = this.data?.vault_id ? this.data?.vault_id : res.data.vaultFormData[0].vault_id;
            } catch (error) {}

            this.securityStateObject = res['vault_user_form_id'].public_key;
            if (res.vault_user_form_id.vault_user_form_id) {
              this.vault_user_form_id = res.vault_user_form_id.vault_user_form_id;
            }
            let findIndex = this.current_template.template[0].singleFieldForm.findIndex((x) => x.record_default);
            if (findIndex == -1) {
              this.updateFormTemplateData();
            } else {
              this.visibility = true;
            }
            this.cd.detectChanges();
            this.applyPrefillData();
          },
          (error) => {}
        )
      );
    }
  }

  inboxAttachmentFile(res) {
    this.subscription.add(
      this._inboxService.attachToInbox([this.data.inbox_attachment_id], this.currentUserData.id, this.vault_user_form_id).subscribe(
        (result: any) => {
          if (result?.data.status == 'success') {
            this.subscription.add(this.subscription.add(this._notifyOpenFormSidebarVault.sendMessage(true)));
            this.dialogRef.close(res);
          }
        },
        (error: any) => {}
      )
    );
  }
  updateFormTemplateData() {
    if (this.is_secure) {
      this.subscription.add(
        this.documentService.getSecurityKeyWidhId(this.currentUserData.id).subscribe((res) => {
          if (res.Items != undefined && res.Items.length) {
            let request = {
              id: this.vault_user_form_id,
              status_progress: 'need to add',
              user_id: this.currentUserData.id,
              form_data: {
                beneFicaryForm: this.beneFicaryForm,
                dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
                showNotes: undefined,
              },
              security_key: '',
              user_pk: this.securityStateObject.public_key,
            };
            request['security_key'] = res.Items[0]['sk'];
            this.savingForm = true;
            this.cd.detectChanges();
            this.subscription.add(
              this.documentService
                .updateFormTampletData(request, res.Items[0], null, this.formEncryptionKey, false, this.sk, false)
                .subscribe((res) => {
                  this.formName();
                  res.type = this.data.vaultType;

                  if (this.data.inbox_attachment_id) {
                    this.inboxAttachmentFile(res);
                  } else {
                    this.dialogRef.close(res);
                  }
                })
            );
          }
        })
      );
    } else {
      const payload = {
        id: this.vault_user_form_id,
        status_progress: 'need to add',
        user_id: this.currentUserData.id,
        form_data: {
          beneFicaryForm: this.beneFicaryForm,
          dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
          showNotes: undefined,
        },
        user_pk: this.securityStateObject.public_key,
      };
      this.savingForm = true;
      this.cd.detectChanges();
      this.subscription.add(
        this.documentService.updateFormTampletData(payload, null, undefined, undefined, false, undefined, false).subscribe(
          (res) => {
            res.type = this.data.vaultType;
            if (this.data.inbox_attachment_id) {
              this.inboxAttachmentFile(res);
            } else {
              this.dialogRef.close(res);
            }
          },
          (error) => {}
        )
      );
      this.formName();
    }
  }

  formName() {
    this.subscription.add(
      this.documentService
        .saveNameWithAction(
          {
            form_name: this.documentForm.controls.documentName.value,
            id: this.vault_user_form_id,
            naming_convention: this.current_template.naming_convention,
            dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
            user_id: this.currentUserData.id,
            current_template: this.current_template,
            filterArrayItems: this.editTemplateBasicForm.filterArrayItems,
            vault_id: this.vault_id,
            vault_list: this.vault_list,
          },
          true
        )
        .subscribe(
          (res) => {
            this.cd.detectChanges();
          },
          (error) => {}
        )
    );
  }

  applyPrefillData(): void {
    if (this.prefillApplied || this.data?.is_edit || !this.data?.prefillData || !this.documentForm) {
      return;
    }

    const dynamicFields = this.documentForm.get('dynamicFieldsForm') as UntypedFormArray;
    if (!dynamicFields?.length && this.prefillRetryCount < 5) {
      this.prefillRetryCount++;
      setTimeout(() => this.applyPrefillData(), 0);
      return;
    }

    const fieldGroup = dynamicFields.at(0) as UntypedFormGroup;
    const controls = fieldGroup?.controls ?? {};
    const keys = Object.keys(controls);

    const firstKey = keys.find((key) => key.toLowerCase().includes('first') && key.toLowerCase().includes('name'));
    const lastKey = keys.find((key) => key.toLowerCase().includes('last') && key.toLowerCase().includes('name'));

    const { first_name, last_name } = this.data.prefillData;

    if (first_name && firstKey) {
      fieldGroup.get(firstKey)!.setValue(first_name);
    }

    if (last_name && lastKey) {
      fieldGroup.get(lastKey)!.setValue(last_name);
    }

    const composedName = [first_name, last_name].filter(Boolean).join(' ').trim();
    if (composedName && this.documentForm.get('documentName')) {
      this.documentForm.get('documentName')!.setValue(composedName);
    }

    this.prefillApplied = true;
    this.cd.detectChanges();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  selectAllContent($event) {
    $event.target.select();
  }

  disableWhiteSpaceOnFirstCharacter(event) {
    if (event.target.selectionStart == 0 && (event.keyCode == 32 || event.keyCode == 9)) {
      event.preventDefault();
    }
  }

  handleInput(event) {
    this.entityName = event.target.value;
  }
}
